import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import AuthCardLayout from "layouts/AuthCardLayout";
import { notify } from "utils/notify";

import RegistrationForm from "components/authentication/RegistrationForm";

import paths from "routes/paths";

const Registration = () => {
  const handleViewManual = async () => {
    try {
      // Fetch the shareable URL from the backend
      const response = await fetch(
        `${
          import.meta.env.VITE_API_BASE_URL
        }/login/generate-registration-manual-url`
      );
      if (!response.ok) {
        throw new Error("Failed to generate URL");
      }
      const { url } = await response.json();

      // Open the generated URL in a new tab
      window.open(url, "_blank");
    } catch (error) {
      console.error("Failed to load the registration manual:", error);
      notify.error("UI_REGISTRATION_MANUAL_LOAD_ERROR");
    }
  };

  return (
    <AuthCardLayout
      leftSideContent={
        <>
          <p className="pt-3 text-white">
            Have a technical issue?
            <br />
            <Button
              as={Link}
              variant="outline-light"
              className="mt-2 px-4"
              to={paths.cardTechnicalIssue}
            >
              Raise a ticket
            </Button>
          </p>
          <p className="pt-3 text-white">
            Have an account?
            <br />
            <Button
              as={Link}
              variant="outline-light"
              className="mt-2 px-4"
              to={paths.cardLogin}
            >
              Log In
            </Button>
          </p>
          <p className="mt-3">
            <Button
              variant="link"
              className="text-white"
              onClick={handleViewManual}
            >
              Registration manual
            </Button>
          </p>
        </>
      }
      footer={false}
    >
      <h3>Register</h3>
      <RegistrationForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default Registration;
